import { is } from 'stdlib/is'

/**
 * Vizsgáljuk, hogy az elem a DOM-ban van még vagy sem.
 * @param el - Az elem, amit vizsgálunk.
 */
export default function isDetachedFromDOM<T extends Node> (
  el: T
): boolean {
  if (el.parentNode === document) {
    return false
  }

  if (is.null(el.parentNode)) {
    return true
  }

  return isDetachedFromDOM(el.parentNode)
}
